module.exports = __webpack_public_path__ + "img/welcome-3.e83145a0.png";